import { render, staticRenderFns } from "./PanelCompetition.vue?vue&type=template&id=24e4e3a7&scoped=true&"
import script from "./PanelCompetition.vue?vue&type=script&lang=js&"
export * from "./PanelCompetition.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetition.vue?vue&type=style&index=0&id=24e4e3a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4e3a7",
  null
  
)

export default component.exports